import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import { SiteConfigProvider } from './contexts/SiteConfigContext';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import PricingPage from './pages/PricingPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import BookingPage from './pages/BookingPage';
import ProductsPage from './pages/ProductsPage';

import AdminLogin from './admin/AdminLogin';
import ProtectedRoute from './admin/ProtectedRoute';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import AdminIdentity from './admin/AdminIdentity';
import AdminHero from './admin/AdminHero';
import AdminServices from './admin/AdminServices';
import AdminPricing from './admin/AdminPricing';
import AdminGallery from './admin/AdminGallery';
import AdminProducts from './admin/AdminProducts';
import AdminContact from './admin/AdminContact';
import AdminBookings from './admin/AdminBookings';
import AdminMessages from './admin/AdminMessages';
import AdminPassword from './admin/AdminPassword';
import AdminSmtp from './admin/AdminSmtp';

import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <SiteConfigProvider>
      <AuthProvider>
        <LanguageProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                {/* Public site */}
                <Route element={<Layout />}>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/leistungen" element={<ServicesPage />} />
                  <Route path="/preise" element={<PricingPage />} />
                  <Route path="/galerie" element={<GalleryPage />} />
                  <Route path="/produkte" element={<ProductsPage />} />
                  <Route path="/kontakt" element={<ContactPage />} />
                  <Route path="/booking" element={<BookingPage />} />
                </Route>

                {/* Admin */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route element={<ProtectedRoute />}>
                  <Route element={<AdminLayout />}>
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/admin/identity" element={<AdminIdentity />} />
                    <Route path="/admin/hero" element={<AdminHero />} />
                    <Route path="/admin/services" element={<AdminServices />} />
                    <Route path="/admin/pricing" element={<AdminPricing />} />
                    <Route path="/admin/gallery" element={<AdminGallery />} />
                    <Route path="/admin/products" element={<AdminProducts />} />
                    <Route path="/admin/contact" element={<AdminContact />} />
                    <Route path="/admin/bookings" element={<AdminBookings />} />
                    <Route path="/admin/messages" element={<AdminMessages />} />
                    <Route path="/admin/smtp" element={<AdminSmtp />} />
                    <Route path="/admin/password" element={<AdminPassword />} />
                  </Route>
                </Route>

                <Route element={<Layout />}>
                  <Route path="*" element={<HomePage />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
          </div>
        </LanguageProvider>
      </AuthProvider>
    </SiteConfigProvider>
  );
}

export default App;
